import React, { useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./AboutMe.css";

export default function AboutMe(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const SCREEN_CONSTANTS = {
    description:
      "🎓 Graduated from SUNY New Paltz with a B.S. degree in Audio Engineering<br>👨‍💻 Recently completed a Software Engineering bootcamp at Flatiron School<br>🚀 Seeking to broaden my horizons, I recently completed a rigorous Software Engineering bootcamp at Flatiron School, where I delved into the world of coding and development. What excites me most about software engineering is its innate capacity for creativity, which seamlessly aligns with my creative inclinations from my audio engineering background. I'm eager to leverage my diverse skill set to contribute to innovative projects and drive impactful change in the tech industry.<br>🌟 Proficient in Full Stack development technologies including React, Flask, SQLAlchemy, SQLite, PostgreSQL and authentication methods.",
    highlights: {
      bullets: [
        "<strong>Languages</strong>: HTML/CSS, Javascript, Python",
        "<strong>Frameworks</strong>: React, Flask, Pygame, SQLAlchemy",
        "<strong>Databases</strong>: SQLite, PostgreSQL",
        "<strong>Concepts/Methodologies</strong>: OOP, ORM, Restful API, Git, Authentication/Authorization, IAM",
        "<strong>Third-Party Web Apps</strong> (Wix, Wordpress, Canva)",
      ],
      heading: "Here are a Few Highlights:",
    },
  };

  const renderHighlight = () => {
    return SCREEN_CONSTANTS.highlights.bullets.map((value, i) => (
      <div className="highlight" key={i}>
        <ul>
          <li dangerouslySetInnerHTML={{__html: value}} />
        </ul>
      </div>
    ));
  };

  return (
    <div
      className="about-me-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="about-me-parent">
        <ScreenHeading title={"About Me"} subHeading={"Why Choose Me?"} />
        <div className="about-me-card">
          <div className="about-me-profile"></div>
          <div className="about-me-details">
            <span className="about-me-description" dangerouslySetInnerHTML={{__html: SCREEN_CONSTANTS.description}} />
            <div className="about-me-highlights">
              <div className="highlight-heading">
                <span>{SCREEN_CONSTANTS.highlights.heading}</span>
              </div>
              {renderHighlight()}
            </div>
            <div className="about-me-options">
              <a href="Miguel_Vasquez_SE_Resume.pdf" download="Miguel_Vasquez_Resume">
                <button className="special-btn btn highlighted-btn">Get Resume</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
